import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * ConfirmModal - Linh kiện xác nhận dùng chung cho toàn dự án
 * @param {boolean} show - Trạng thái hiển thị
 * @param {function} onHide - Hàm đóng modal
 * @param {function} onConfirm - Hàm xử lý khi nhấn Đồng ý
 * @param {string} title - Tiêu đề modal
 * @param {string} message - Nội dung thông báo
 * @param {string} variant - Kiểu màu sắc (primary, danger, success, warning)
 * @param {boolean} loading - Trạng thái đang xử lý
 */
const ConfirmModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  title = 'Xác nhận hành động', 
  message = 'Bạn có chắc chắn muốn thực hiện hành động này?', 
  variant = 'primary',
  loading = false,
  children
}) => {
  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      size={children ? "md" : "sm"}
      contentClassName="rounded-4 border-0 shadow"
      animation={false}
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fs-6 fw-bold text-dark">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-3 text-center">
         <div className={`mb-3 mx-auto d-flex align-items-center justify-content-center bg-${variant} bg-opacity-10 text-${variant} rounded-circle`} style={{ width: '50px', height: '50px' }}>
            <i className={`fas ${
              variant === 'danger' ? 'fa-exclamation-triangle' : 
              variant === 'success' ? 'fa-check-circle' : 
              variant === 'warning' ? 'fa-exclamation-circle' : 
              'fa-question-circle'
            } fa-lg`}></i>
         </div>
         {message && <p className="small mb-2 text-muted px-2 fw-bold">{message}</p>}
         {children}
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 justify-content-center gap-2 pb-4">
        <Button 
          variant="light" 
          size="sm" 
          className="rounded-pill px-3" 
          onClick={onHide}
          disabled={loading}
        >
          Hủy bỏ
        </Button>
        <Button 
          variant={variant} 
          size="sm" 
          className="rounded-pill px-4 shadow-sm" 
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? (
            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          ) : null}
          Đồng ý
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
